class BookingsController {
    constructor($filter, $translate,$stateParams, cacheService, languageService) {
        'ngInject';
        this.$translate = $translate;
        this.bookings = [cacheService.get('bookingReference')];

        // this.languageService = languageService;
        // this.$stateParams = $stateParams;
        // this.languageService.setLanguage(this.$stateParams.locale || null);

    }
}

export default BookingsController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/bookings.controller.js